import React, {ReactNode} from 'react';

export interface PreventParentScrollWrapperProps {
  children: ReactNode;
}

export default class PreventParentScrollWrapper extends React.Component<PreventParentScrollWrapperProps> {
  divRef = React.createRef<HTMLDivElement>();

  componentDidMount(): void {
    if (this.divRef.current) {
      this.divRef.current.addEventListener('touchstart', (e) => {
        e.stopPropagation();
      });
      this.divRef.current.addEventListener('touchmove', (e) => {
        e.stopPropagation();
      });
      this.divRef.current.addEventListener('wheel', (e) => {
        e.stopPropagation();
      });
    }
  }

  componentWillUnmount(): void {
    if (this.divRef.current) {
      this.divRef.current.removeEventListener('touchstart', (e) => {
        e.stopPropagation();
      });
      this.divRef.current.removeEventListener('touchmove', (e) => {
        e.stopPropagation();
      });
      this.divRef.current.removeEventListener('wheel', (e) => {
        e.stopPropagation();
      });
    }
  }

  render(): JSX.Element {
    return <div ref={this.divRef}>{this.props.children}</div>;
  }
}
